import type { Column } from '@table-library/react-table-library/compact'

export type CardTableColumn = Column & {
	width: string
	align?: 'right' | 'center'
	padding?: string
}

const mutedBackground = `
	background-color: rgb(var(--card));
	background-image: linear-gradient(rgb(var(--muted) / 0.5), rgb(var(--muted) / 0.5));
`

export const cardTableStyles = {
	Table: `
		height: 100%;
		max-height: 100%;
		align-content: start;
		font-size: 12px;
		color: rgb(var(--foreground));

		th:first-of-type {
			z-index: 5;
		}

		td input[type="checkbox"],
		th input[type="checkbox"] {
			display: block;
			width: 14px;
			height: 14px;
			cursor: pointer;
			accent-color: rgb(var(--primary));
		}
	`,
	HeaderCell: `
		${mutedBackground}
		border-bottom: 1px solid rgb(var(--border));
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.05em;
		color: rgb(var(--muted-foreground));
	`,
	Row: `
		cursor: pointer;

		&:not(:last-of-type) > .td {
			border-bottom: 1px solid rgb(var(--border));
		}

		&:nth-of-type(even) td {
			${mutedBackground}
		}

		&:hover td {
			background-image: linear-gradient(rgb(var(--muted)), rgb(var(--muted)));
		}

		&.row-select-selected td,
		&.row-select-single-selected td {
			background-image: linear-gradient(rgb(var(--primary-soft)), rgb(var(--primary-soft)));
		}
	`,
	BaseCell: `
		padding: 12px;
		font-size: 12px;
		color: rgb(var(--foreground));
		background-color: rgb(var(--card));
		transition: background-image 150ms;

		&:nth-of-type(1) {
			left: 0;
			position: sticky;
			z-index: 3;
		}

		&:nth-of-type(2) {
			left: 40px;
		}
	`
}

export const getCardTableStyles = (
	columns: CardTableColumn[],
	{ selectable = true, clickableRows = true } = {}
) => {
	const offset = selectable ? 2 : 1

	return {
		...cardTableStyles,
		Row: clickableRows ? cardTableStyles.Row : `${cardTableStyles.Row}; cursor: default;`,
		Table: `
			${cardTableStyles.Table};
			--data-table-library_grid-template-columns: ${selectable ? '40px ' : ''}${columns
				.map((column) => column.width)
				.join(' ')} !important;
			${columns
				.map((column, index) => {
					const nth = index + offset
					const alignRule = column.align
						? `th:nth-of-type(${nth}) { text-align: ${column.align}; }`
						: ''
					const paddingRule = column.padding
						? `th:nth-of-type(${nth}), td:nth-of-type(${nth}) { padding: ${column.padding}; }`
						: ''

					return `${alignRule}${paddingRule}`
				})
				.join('\n')}
		`
	}
}
